import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const handleClick = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header>
      <nav>
        <div className="nav-container">
          <ul className="nav-menu">
            <li><a href="#artists" onClick={(e) => handleClick(e, 'artists')}>ARTISTS</a></li>
            <li><a href="#releases" onClick={(e) => handleClick(e, 'releases')}>RELEASES</a></li>
            <li><a href="#about" onClick={(e) => handleClick(e, 'about')}>ABOUT</a></li>
            <li><a href="#contact" onClick={(e) => handleClick(e, 'contact')}>CONTACT</a></li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;

